module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-detail"
  }, [_c('table', {
    staticClass: "w-100 head-table"
  }, [_vm._m(0), _vm._v(" "), _c('thead', [_c('tr', [_c('th', [_vm._v("Producto")]), _vm._v(" "), _c('th', [_vm._v("Precio de Venta")]), _vm._v(" "), _c('th', [_vm._v("Cantidad")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), (_vm.orderState === 'GIVEN') ? _c('th', [_vm._v("Acciones")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "align-center description-cell txt-left"
    }, [_c('div', {
      staticClass: "img-product"
    }, [_c('img', {
      attrs: {
        "src": item.productImage,
        "alt": "imagen del producto"
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_c('i', [_c('b', [_vm._v(_vm._s(item.productName))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.description))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.salePrice))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))]), _vm._v(" "), (_vm.orderState === 'GIVEN') ? _c('td', [_c('button', {
      staticClass: "btn-table",
      attrs: {
        "title": "Calificar producto"
      },
      on: {
        "click": function($event) {
          _vm.$emit('rating', item)
        }
      }
    }, [_c('img', {
      staticClass: "table-view",
      attrs: {
        "src": "/static/img/icons/comments.svg",
        "alt": "Ver detalle"
      }
    })])]) : _vm._e()])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "d-flex"
  }, [_c('col', {
    staticClass: "description-col"
  }), _vm._v(" "), _c('col', {
    staticClass: "col-style"
  }), _vm._v(" "), _c('col', {
    staticClass: "col-style"
  }), _vm._v(" "), _c('col', {
    staticClass: "col-style"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-242d2717","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/table-detail-product.vue
// module id = 1081
// module chunks = 8